import { createFileRoute } from "@tanstack/react-router"
import { ShelfTypeOrderPage } from "@/features/shelf-type-order/components/ShelfTypeOrderPage"
import { shelfTypeOrderQuery } from "@/features/shelf-type-order/hooks/useShelfTypeOrder"

export const Route = createFileRoute("/(authenticated)/settings/shelf-types/")({
  loader: ({ context }) => {
    void context.queryClient.ensureQueryData(shelfTypeOrderQuery())
  },
  component: ShelfTypeOrderPage,
})
